import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'

// import { navigationOptionsDefault } from '../config/navigation'

import InfoOverviewScreen from '../screens/info/InfoOverviewScreen'
import commonStackNavigatorScreens from './commonStackNavigatorScreens'
import { commonScreenOptions } from '../config/navigation'

const Stack = createStackNavigator()

const InfoNavigator = () => {
  return (
    <Stack.Navigator
      initialRouteName="Info"
      screenOptions={{ ...commonScreenOptions }}
    >
      <Stack.Screen
        name="Info"
        component={InfoOverviewScreen}
        options={{ title: 'Information', headerShown: false }}
      />

      {commonStackNavigatorScreens.map(
        ({ name, component, options, title }) => (
          <Stack.Screen
            name={name}
            title={title}
            component={component}
            options={options}
            key={name}
          />
        )
      )}
    </Stack.Navigator>
  )
}

export default InfoNavigator
